import type {SenseAction} from 'src/action-creators/types';
import type {ReducerCombiner} from 'src/types/redux';

import {combineReducers} from 'redux';

import cache from './cache';
import error from './error';
import request from './request';


type Reducers = {
  cache: typeof cache;
  error: typeof error;
  request: typeof request;
};

const reducer: ReducerCombiner<Reducers, SenseAction> = combineReducers<
  Reducers,
  SenseAction
>({
  // @ts-expect-error - TS2322 - Type '(state: CacheState | null | undefined, action: SenseCacheAction) => CacheState' is not assignable to type 'Reducer<(state: CacheState | null | undefined, action: SenseCacheAction) => CacheState, SenseAction>'.
  cache,
  // @ts-expect-error - TS2322 - Type '(state: RequestState | null | undefined, action: SenseRequestAction) => RequestState' is not assignable to type 'Reducer<(state: RequestState | null | undefined, action: SenseRequestAction) => RequestState, SenseAction>'.
  request,
  // @ts-expect-error - TS2322 - Type '(state: ErrorState | null | undefined, action: SenseCacheErrorAction) => ErrorState' is not assignable to type 'Reducer<(state: ErrorState | null | undefined, action: SenseCacheErrorAction) => ErrorState, SenseAction>'.
  error,
});

export default reducer;
